import React, { useEffect, useState, useRef } from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardMedia,
    IconButton,
    Tooltip,
} from "@mui/material";
import { PlayArrow, Pause, Delete } from "@mui/icons-material";
import axios from "axios";
import Navbar from "../component/Navbar";
import BottomBar from "../component/BottomBar";

const FavoritesPage = () => {
    const [favorites, setFavorites] = useState([]);
    const [isPlayingIndex, setIsPlayingIndex] = useState(null);
    const audioRefs = useRef([]);
    const userId = parseInt(localStorage.getItem("userid") || "1");

    useEffect(() => {
        axios
            .get("https://music-endpoint.onrender.com/favorites/get/songs", {
                params: { userid: userId },
            })
            .then((response) => {
                const data = response.data || [];
                const formatted = data.map((song) => ({
                    title: song.songName,
                    songId: song.id,
                    liked: true,
                    imageUrl: `https://music-endpoint.onrender.com/songs/details/${encodeURIComponent(song.songName)}`,
                }));
                setFavorites(formatted);
            })
            .catch((error) => {
                console.error("Failed to fetch favorites:", error);
            });
    }, [userId]);

    const handlePlayPause = async (index) => {
        const audio = audioRefs.current[index];
        if (!audio) return;

        if (isPlayingIndex === index) {
            audio.pause();
            setIsPlayingIndex(null);
        } else {
            if (isPlayingIndex !== null && audioRefs.current[isPlayingIndex]) {
                audioRefs.current[isPlayingIndex].pause();
            }
            const audioURL = `https://music-endpoint.onrender.com/songs/play/${encodeURIComponent(favorites[index].title)}`;
            audio.src = audioURL;
            await audio.play();
            setIsPlayingIndex(index);
        }
    };

    const handleRemoveFavorite = async (index) => {
        const song = favorites[index];
        try {
            await axios.delete("https://music-endpoint.onrender.com/favorites/delete/songs", {
                params: {
                    userid: userId,
                    songid: song.songId,
                },
            });
            const updatedFavorites = favorites.filter((_, i) => i !== index);
            setFavorites(updatedFavorites);
        } catch (error) {
            console.error("Failed to remove favorite:", error);
        }
    };

    return (
        <Box sx={{ height: "100vh" }}>
            <Navbar />
            <Grid container spacing={2} sx={{ padding: 2, marginBottom: 7,overflowY: "scroll", height: "90vh" }}>
                {favorites.length === 0 ? (
                    <Grid item xs={12}>
                        <Typography variant="h6" align="center">
                            No favorite songs found.
                        </Typography>
                    </Grid>
                ) : (
                    favorites.map((song, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
                            <Card
                                sx={{
                                    backgroundColor: "#1E1E1E",
                                    color: "#F9FAFB",
                                    borderRadius: 3,
                                    boxShadow: 3,
                                    width: "250px",
                                    height: 280,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    image={song.imageUrl}
                                    alt={song.title}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "/fallback-image.jpg"; // fallback in public/
                                    }}
                                    sx={{
                                        height: 180,
                                        objectFit: "cover",
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                    }}
                                />
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            mb: 1,
                                        }}
                                    >
                                        {song.title}
                                    </Typography>
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Tooltip title="Remove from Favorites">
                                            <IconButton onClick={() => handleRemoveFavorite(index)} sx={{ color: "red" }}>
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={isPlayingIndex === index ? "Pause" : "Play"}>
                                            <IconButton onClick={() => handlePlayPause(index)} color="primary">
                                                {isPlayingIndex === index ? (
                                                    <Pause sx={{ color: "gray", fontSize: 30 }} />
                                                ) : (
                                                    <PlayArrow sx={{ color: "gray", fontSize: 30 }} />
                                                )}
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </CardContent>
                                <audio
                                    ref={(el) => (audioRefs.current[index] = el)}
                                    onEnded={() => setIsPlayingIndex(null)}
                                    onError={(e) => console.error(`Audio error for ${song.title}:`, e)}
                                />
                            </Card>
                        </Grid>
                    ))
                )}
            </Grid>

            <BottomBar
                audioRef={audioRefs.current[isPlayingIndex]}
                track={favorites[isPlayingIndex]}
                isPlaying={isPlayingIndex !== null}
                onPlayPause={() => handlePlayPause(isPlayingIndex)}
                onNext={() => {
                    const next = (isPlayingIndex + 1) % favorites.length;
                    handlePlayPause(next);
                }}
                onPrev={() => {
                    const prev = (isPlayingIndex - 1 + favorites.length) % favorites.length;
                    handlePlayPause(prev);
                }}
            />
        </Box>
    );
};

export default FavoritesPage;
